import { cssVariables } from "@/utils/utils";
import { Button, Flex, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../../../../common/components/views/Ellipsis";
import { resolveInstitutionLogo } from "../../../../../../institution/utils";
import { ErrorAlert } from "../../../../components/calc-result/ErrorAlert";
import { RecommendationButton } from "../../../../components/calc-result/RecommendationButton";
import { CalcResult } from "../../../../types";
import { PasCalcResultData } from "../../../types";

type Props = {
  item: CalcResult<PasCalcResultData>;
  rotate: () => void;
  handleItemRecommendation?: (itemId: string, activation: boolean) => void;
};

export const PasCalcResultInfo = ({ item, handleItemRecommendation, rotate }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex gap="middle" style={{ height: "100%" }}>
      <div style={{ marginTop: 10 }}>
        <img
          width="100"
          height="60"
          style={{ objectFit: "contain" }}
          src={resolveInstitutionLogo(item.insuranceInstitution)}
          alt="Institution Logo"
        />
      </div>

      <Flex justify="space-between" vertical flex={1} style={{ minWidth: 0 }}>
        <div>
          <Flex gap="middle">
            <h2 style={{ marginBottom: 14 }}>
              {item.insuranceInstitution.name} {item.coverage}
            </h2>

            {handleItemRecommendation ? (
              <RecommendationButton item={item} handleItemRecommendation={handleItemRecommendation} />
            ) : undefined}
          </Flex>

          <div style={{ maxHeight: 118, overflowY: "auto" }}>
            {item.error ? (
              <ErrorAlert item={item} />
            ) : (
              <>
                <b>{t("contract.enums.insuranceCoverageType._label")}</b>

                <table>
                  <tbody>
                    {item.data?.coverages?.map((coverage) => {
                      return (
                        <tr key={coverage.name}>
                          <td>{coverage.name}</td>
                          <td style={{ paddingLeft: 16, textAlign: "right", whiteSpace: "nowrap" }}>
                            <b>{coverage.limit}</b>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {item.data?.warnings.length ? (
                  <Tag
                    style={{ minWidth: 0, display: "block", paddingRight: 24, marginTop: 8, marginRight: 0 }}
                    icon={<AntIcon type="exclamation" />}
                    color="warning"
                  >
                    <Ellipsis style={{ color: cssVariables.colorYellow }}>{item.data?.warnings.join(" ")}</Ellipsis>
                  </Tag>
                ) : undefined}
              </>
            )}
          </div>
        </div>

        <Space.Compact block>
          <Button style={{ flex: 1 }} disabled={!!item.error} onClick={rotate}>
            {t("calc.travel.results.additionalInfo")}
          </Button>
          <Button style={{ flex: 1 }} disabled={!!item.error} onClick={rotate}>
            {t("common.documents")}
          </Button>
        </Space.Compact>
      </Flex>
    </Flex>
  );
};
